/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days until then`)
};

const es_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} días hasta entonces`)
};

const de_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage bis dahin`)
};

const nl_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dagen tot dan`)
};

const fr_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours jusqu'à présent`)
};

const it_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} giorni da qui`)
};

const pt_br2_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias até então`)
};

const pt_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias até lá`)
};

const ja_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 日後`)
};

const zh_dd_until = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还有 ${i?.days} 天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ days: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_until = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_until(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_until", locale)
	if (locale === "en") return en_dd_until(inputs)
	if (locale === "es") return es_dd_until(inputs)
	if (locale === "de") return de_dd_until(inputs)
	if (locale === "nl") return nl_dd_until(inputs)
	if (locale === "fr") return fr_dd_until(inputs)
	if (locale === "it") return it_dd_until(inputs)
	if (locale === "pt-BR") return pt_br2_dd_until(inputs)
	if (locale === "pt") return pt_dd_until(inputs)
	if (locale === "ja") return ja_dd_until(inputs)
	return zh_dd_until(inputs)
};